import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  PartnerListExportToFileStart,
  PartnerListInitialState,
  PartnerListLoad,
  PartnerListLoadByFilter,
} from './partner-list.actions';
import { PartnerListState, PartnerListStateModel } from './partner-list.state';
import { PartnerBrief, PartnerListSearchCriteria, PartnerSearchCriteria } from '../models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';
import { MatDialogRef } from '@angular/material/dialog';
import { ExportDialogComponent } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class PartnerListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<PartnerListStateModel> = this.store.select(PartnerListState.getState);
  items$: Observable<PartnerBrief[]> = this.store.select(PartnerListState.getItems);
  loaded$: Observable<boolean> = this.store.select(PartnerListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Partners)
      .subscribe((searchCriteria: PartnerSearchCriteria) => {
        this.store.dispatch(new PartnerListLoad(searchCriteria));
      });
  }

  loadListForDialog(searchCriteria: PartnerListSearchCriteria): void {
    this.store.dispatch(new PartnerListLoad(searchCriteria));
  }

  setInitialState(): void {
    this.store.dispatch(new PartnerListInitialState());
  }

  startExportToFile(name: string, dialogRef: MatDialogRef<ExportDialogComponent>, navigationNeeded: boolean): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Partners)
      .subscribe((searchItem: PartnerListSearchCriteria) => {
        const { size: _size, page: _page, ...filterView } = searchItem;
        this.store.dispatch(
          new PartnerListExportToFileStart({
            name,
            filterView,
            dialogRef,
            navigationNeeded,
          }),
        );
      });
  }

  loadListByFilter(searchCriteria: PartnerListSearchCriteria): void {
    this.store.dispatch(new PartnerListLoadByFilter(searchCriteria));
  }
}
